import styled from 'styled-components/macro';

export const ListContainer = styled.div`
  width: 100%;
`;

export * from './StudentModuleLearning';
